import { Box, Typography } from '@mui/material';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE } from '../utils/constants';
import Panel from './Panel';
import PanelTitle from './PanelTitle';
import ProjectButton from './ProjectButton';

/** "Projects in these dates" - where the team's open work sits; click one to filter the page to it. */
export default function ProjectsPanel({ projects, hoursOf, selected, onSelect }) {
  return (
    <Panel sx={{ p: 2.5 }}>
      <PanelTitle
        title="Projects in these dates"
        hint="Click one to filter the page to it"
        right={<Typography sx={{ fontSize: 13, fontWeight: 700, color: WD.inkMuted, ...FIGURE }}>{projects.length}</Typography>}
      />
      {projects.length ? (
        <Box sx={{ mt: 1.5, maxHeight: 340, overflowY: 'auto', display: 'grid', gap: 0.5 }}>
          {projects.map((project) => (
            <ProjectButton key={project.projectId} project={project} hours={hoursOf(project.projectId)} selected={project.projectId === selected} onSelect={onSelect} />
          ))}
        </Box>
      ) : (
        <NoDataFound message="No open work falls in these dates." />
      )}
    </Panel>
  );
}
